/* Galand Vanille — Carrousel photos cartes produit (mobile)
   Met à jour la barre de progression CSS en fonction de la photo visible. */
(function () {
  if (window.__gvCardCarouselInit) return;
  window.__gvCardCarouselInit = true;

  function initOne(carousel) {
    var track = carousel.querySelector('.gv-card-carousel__track');
    var slides = carousel.querySelectorAll('.gv-card-carousel__slide');
    var dots = carousel.querySelector('.gv-card-carousel__dots');
    if (!track || slides.length < 2 || !dots) return;

    if (carousel.dataset.gvInit === '1') return;
    carousel.dataset.gvInit = '1';

    var slidesArr = Array.prototype.slice.call(slides);
    var total = slidesArr.length;

    function setProgress(idx) {
      // Pourcentage = (index actif + 1) / total (conservé pour compat)
      var pct = ((idx + 1) / total) * 100;
      dots.style.setProperty('--gv-progress', pct + '%');
      // Style "Dior" : segment fixe qui glisse — l'index et le total pilotent translateX
      dots.style.setProperty('--gv-count', total);
      dots.style.setProperty('--gv-index', idx);
    }

    // Position initiale : photo 1
    setProgress(0);

    if (typeof IntersectionObserver === 'function') {
      var observer = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (e) {
          if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
        });
        if (best && best.intersectionRatio > 0.55) {
          var idx = slidesArr.indexOf(best.target);
          if (idx >= 0) setProgress(idx);
        }
      }, { root: track, threshold: [0.55, 0.85] });
      slidesArr.forEach(function (s) { observer.observe(s); });
    } else {
      track.addEventListener('scroll', function () {
        var w = track.clientWidth;
        if (!w) return;
        var idx = Math.round(track.scrollLeft / w);
        idx = Math.max(0, Math.min(total - 1, idx));
        setProgress(idx);
      }, { passive: true });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-gv-card-carousel]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:reorder', initAll);

  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function (mutations) {
      var needsInit = false;
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && (n.matches && (n.matches('[data-gv-card-carousel]') || (n.querySelector && n.querySelector('[data-gv-card-carousel]'))))) {
            needsInit = true;
          }
        });
      });
      if (needsInit) initAll();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
